window.addEventListener("load", function () {
    const userAgent = navigator.userAgent || navigator.vendor || window.opera;

    if (/android/i.test(userAgent)) {
        // Remove iOS button if the user is on Android
        $('.M-apple').remove();
        // Remove Level Up button for Android users
        $('.M-levelup').remove();
    } else if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
        // Remove Android button if the user is on iOS
        $('.M-google').remove();
        // Remove Level Up button for iOS users
        $('.M-levelup').remove();
    }

    // $('#vxphl-ld-25-a-header .btn-hot').on('click', function (e) {
    //     e.preventDefault();

    //     const mainSwiper = $('.main-swiper')[0].swiper;
    //     mainSwiper.slideTo(1);
    // });
});